import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-upload-invoice-milestone',
  templateUrl: './upload-invoice-milestone.component.html',
  styleUrls: ['./upload-invoice-milestone.component.scss']
})
export class UploadInvoiceMilestoneComponent {

  constructor(private router: Router) {}

  onIniciarClick(): void {
    this.router.navigate(['/invoices/create']);
  }
}
